import { Component } from '@angular/core'
import { DataCheckerService, Toaster } from '@tokeet-frontend/tv3-platform'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { DataDictService } from '@tv3/services/data-dict.service'
import { ReviewService } from '@tokeet-frontend/reviews'
import { BookingReviewBaseComponent } from '../booking-review-base'

@Component({
  selector: 'app-expedia-booking-review',
  templateUrl: './expedia-booking-review.component.html',
  styleUrls: ['./expedia-booking-review.component.scss'],
})
export class ExpediaBookingReviewComponent extends BookingReviewBaseComponent {
  constructor(
    fb: FormBuilder,
    store: Store<any>,
    reviewService: ReviewService,
    toaster: Toaster,
    dataDictService: DataDictService,
    dataChecker: DataCheckerService
  ) {
    super(fb, store, reviewService, toaster, dataDictService, dataChecker)
  }

  onReviewGuest(): void {
    // Expedia reviews are read-only in Advance, so there is no guest review CTA.
  }
}
